import React from "react";
import logo from "../images/icd-logo.png";
const IR330Header = (props) => {
  return (
    <div className="row header" style={{ background: "#001D4A", color: "#ffffff" }}>
      <div className="col-md-3">
        <div className="logo">
          <img src={logo} className="icdlogo" alt="logo" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="title">Tax code declaration</div>
      </div>
      <div className="col-md-3 text-right">
        <div className="iddate">
          IR330
          <span>June 2024</span>
        </div>
      </div>
    </div>
  );
};

export default IR330Header;
